import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const { setLang } = useLang();

  useEffect(() => {
    if (!localStorage.getItem("atlas_token")) {
      setReady(true);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => localStorage.removeItem("atlas_token")).finally(() => setReady(true));
  }, []);

  const signIn = useCallback((data) => {
    localStorage.setItem("atlas_token", data.token);
    setUser(data.user);
    if (data.user.role === "employee" && data.user.lang) setLang(data.user.lang);
  }, [setLang]);

  const signOut = useCallback(() => {
    localStorage.removeItem("atlas_token");
    setUser(null);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, ready, signIn, signOut }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const homeFor = (role) => ({ admin: "/admin", employee: "/app" }[role] || "/login");
